import React, { useEffect, useState } from 'react';
import axios from 'axios';
import $ from 'jquery';

import 'jquery/dist/jquery.min.js';
import 'datatables.net-dt/js/dataTables.dataTables';
import 'datatables.net-buttons/js/dataTables.buttons.js';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.flash.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-dt/css/jquery.dataTables.min.css';

const RegisteredStudent = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios.get('/total-registered-student').then((res) => {
      setData(res.data.data);
      console.log(res.data.data);

      setTimeout(() => {
        $('#example').DataTable({
          pagingType: 'full_numbers',
          pageLength: 15,
          processing: true,
          dom: 'Bfrtip',
          buttons: ['copy', 'csv', 'print', 'excelHtml5', 'pdf'],
        });
      }, 1000);
    });
  }, []);

  return (
    <div style={{ width: '100%' }}>
      <div className="flex flex-col md:flex-row" style={{ width: '100%' }}>
        <section style={{ width: '100%' }}>
          <div
            id="main"
            className="main-content flex-1 bg-gray-100 mt-12 md:mt-2 pb-24 md:pb-5"
            style={{ width: '100%' }}
          >
            <div className="flex flex-wrap bg-white" style={{ width: '100%' }}>
              <div className="flex flex-col bg-white" style={{ width: '100%' }}>
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="overflow-x-auto">
                      <div className="MainDiv">
                        <div className="container p-5">
                          <table id="example" className="table table-hover table-bordered">
                            <thead>
                              <tr>
                                <th>Sl.No</th>
                                {/* <th>Application No</th> */}
                                <th>Student Name</th>
                                <th>Father's Name</th>
                                <th>Mother's Name</th>
                                <th>Gender</th>
                                <th>Mobile No</th>
                                <th>Guardian No</th>
                                <th>Email-ID</th>
                                <th>Program</th>
                                <th>Country</th>
                                <th>State</th>
                                <th>Pincode</th>
                                <th>Registered Date</th>
                                <th>Password</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.map((result, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{result.name}</td>
                                  <td>{result.personalDetails?.[0]?.fatherName || 'Null'}</td>
                                  <td>{result.personalDetails?.[0]?.motherName || 'Null'}</td>
                                  <td>{result.gender}</td>
                                  <td>{result.personalDetails?.[0]?.guardianNo || 'Null'}</td>
                                  <td>{result.mobileNo}</td>
                                  <td>{result.email}</td>
                                  <td>{result.program}</td>
                                  <td>{result.country}</td>
                                  <td>{result.personalDetails?.[0]?.state || 'Null'}</td>
                                  <td>{result.personalDetails?.[0]?.pincode || 'Null'}</td>
                                  <td>{result.createdAt}</td>
                                  <td>{result.password}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default RegisteredStudent;
